
































































import { defineComponent, ref, useContext, computed, useFetch } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { BUNDLE_TYPE_ID, CONFIGURABLE_TYPE_ID, META_PDP_SET_NAME } from '~/utils/constants/product';

import PurchaseOptionCard from '~/components/solepro/ProductPage/PurchaseOptions/PurchaseOptionCard.vue';
import BundlePurchaseOptionCard from '~/components/solepro/ProductPage/PurchaseOptions/BundlePurchaseOptionCard.vue';
import { Pagination, Navigation } from 'swiper'
import { getFirstPriceLabel, getSecondPriceLabel, getOptionsBlock, getGroupInfos } from '~/utils/helpers/product';
import ConfigureBundle from './ConfigureBundle.vue';

import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

// Import Swiper styles
//import 'swiper/swiper-bundle.css'
import { getIsBook } from '~/utils/solepro/products';
import PaymentMethodsIcons from '../PaymentMethodsIcons.vue';
import { equalizePurchaseSlides, observeScalapay } from '~/utils/helpers/solepro/product';
import OfferGroup from './OfferGroups/OfferGroup.vue';
import { useConfig } from '~/composables';
import axios from 'axios';
import { calcolaBoxInWidth, getAxiosConfigs } from '~/utils/solepro/functions';
import ClientOnly from 'vue-client-only';
import Teleport from 'vue2-teleport';


SwiperCore.use([Pagination, Navigation])
export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        },
        showFrequencies:{
            type: Boolean,
            deafault: true
        },
        showSuggestedSku:{
            type: Boolean,
            deafault: false
        },
        moreCards:{
            type: Array as PropType<any>,
            default: ()=>{ return []}
        },
        moreOptions:{
            type: Object as PropType<any>,
            default: ()=>{ return {}}
        }
    },
    data() {
        return {
            isSSR: true,
            swiperInstance: null
        }
    },
    components: {
        PaymentMethodsIcons,
        PurchaseOptionCard,
        BundlePurchaseOptionCard,
        ConfigureBundle,
        Swiper,
        SwiperSlide,
        OfferGroup,
        ClientOnly,
        Teleport

    },
    setup(props) {
        const { product } = props;
        const { app } = useContext();
        const { i18n } = app;
        const { config } = useConfig()

        const useCarousel = ref(false);
        const paymentFrequenciesChoosen = ref({});
        const isConfigurable = product.typeId == CONFIGURABLE_TYPE_ID;
        const isMetaPDP = product.attributeSetName == META_PDP_SET_NAME;
        const optionsBlock = ref({})
        const cardsQty = ref(0)
        const mdMaxWidth = computed(()=>{
            if(process.client && cardsQty.value>0){
              const numeroMaxCards = calcolaBoxInWidth(document.querySelector('.section-purchase-options').getBoundingClientRect().width-40-53)
              const max =  numeroMaxCards * 340 + (numeroMaxCards - 1) * 20
              const effective = cardsQty.value>0 ? cardsQty.value*340 +(cardsQty.value - 1) * 20 : 0
              return Math.min(max, effective)
            }else return null
        })
        const showNavigation = computed(()=>{
            if(process.client && cardsQty.value>0){
              const numeroMaxCards = calcolaBoxInWidth(document.querySelector('.section-purchase-options').getBoundingClientRect().width-40-53)
              return cardsQty.value > numeroMaxCards
            }else return null
        })

        const getComponent = (item) => {
            if (item.typeId == CONFIGURABLE_TYPE_ID) {
                if (item.configurable_options.find(el => el.attribute_code != 'tipo_abbonamento')) {
                    optionsBlock.value[item.sku] = getOptionsBlock(item)
                }
                return PurchaseOptionCard

            } else {
                return BundlePurchaseOptionCard

            }
        }


        const optionsConstant = isMetaPDP ? (product.additionalProducts || []).map(el => {
            const nextItem = product.additionalProducts.find(nxt => nxt.modulesInCartQty && el.modulesInCartQty && nxt.modulesInCartQty.min > el.modulesInCartQty.min)
            return {
                item: el,
                nextItem,
                component: getComponent(el)
            }
        })
            : [{
                item: product,
                nextItem: null,
                component: getComponent(isConfigurable) /** todo check why we are passing a bool?? */
            }
            ]
        optionsConstant.forEach(opt => {
            paymentFrequenciesChoosen.value[opt.item.sku] = opt.item.entryBillingPeriod ?? opt.item.paymentFrequencies[opt.item.paymentFrequencies.length - 1]
        })
        const options = ref<any>(optionsConstant) /** Options previously calculated or offergroups */
        const swiperProps = {
            modules: [Navigation, Pagination],
            slideClass: "slide",
            spaceBetween: 20,
            navigation: {
                prevEl: '.section-purchase-options .navigation-prev',
                nextEl: '.section-purchase-options .navigation-next',
            },
            pagination: false,
            slidesPerView: 3,
            slidesPerGroup: 3,
            direction: "horizontal",
            loop: false, // Disabilita il loop
            breakpoints: {
                0: { // Inizia da 0px fino a 1024px
                    enabled: false,
                    slidesPerView: 'auto', // Mostra una slide per riga (o auto a seconda del contenuto)
                    freeMode: true, // Permette lo scroll libero senza snap delle slide
                    navigation: false, // Disabilita le frecce
                    allowTouchMove: true, // Permette lo scorrimento
                    grabCursor: false, // Non mostra il cursore di "mano"
                    direction: "vertical",
                },
                1024: {
                    enabled: true,
                    slidesPerView: 'auto',
                    direction: "horizontal",
                    allowTouchMove: true,
                    grabCursor: true,
                    freeMode: false,

                }
            },
        }
        
        const hasOnlyNotBuyable = options.value.length > 0 && options.value.every(el => !el.item.buyable)

        useFetch(async ()=>{
            const skus = product.offer_groups && product.offer_groups.length>0 ? product.offer_groups.map(el => el.skus.split(',')).flat() : [];
            if(skus.length>0){
                const { data: groupskus } = await axios.post('/sole-api/product/pro/getOfferGroupsProducts', { skus }, { ...getAxiosConfigs(app, config) })
                const groups = product.offer_groups.map(group => {
                    return getGroupInfos(group, groupskus)
                });
                /** ordered mix of all skus and groups */
                const keys = [...new Set([...product.additionalSkus.split(','),...product.offer_groups.map(el=>'group-'+el.record_id)])]
                options.value = keys.map(el=>{
                    if(el.match(/^group-/g)){
                        return getGroupInfos(groups.find(g=>g.record_id==el.replace('group-','')), groupskus)
                    }else{
                        return options.value.find(opt=>opt.item.sku==el)
                    }
                })
            }

     

        })
        const staticOptions = computed(()=>[...options.value.filter(el=>!el.record_id), ...props.moreCards.filter(el=>el.item.modulesInCartQty && el.item.modulesInCartQty.min>0)])
        const optionsToDraw = computed(()=>[...optionsConstant, ...props.moreCards])
        const cardsCount = computed(()=>{
            try{
                return Object.values(props.moreOptions).map(el=>(el as Array<any>).map(o=>o?.options).filter(e=>!!e)).flat().flat().length
            }catch(e){
                return optionsToDraw.value.length
            }
        });
        return {
            isConfigurable,
            isBundle: product.typeId == BUNDLE_TYPE_ID,
            isMetaPDP,
            options: optionsToDraw,
            cardsCount,
            staticOptions,
            swiperProps,
            useCarousel,
            paymentFrequenciesChoosen,
            i18n,
            optionsBlock: computed(()=>{return {...optionsBlock.value, ...props.moreOptions}}),
            isBook: getIsBook(props.product),
            hasOnlyNotBuyable,
            cardsQty,
            mdMaxWidth,
            showNavigation
        }
    },
    mounted() {
        this.isSSR = false;
        this.cardsQty = this.$el.querySelectorAll('.purchase-card-wrapper').length  
    },
    watch: {
        cardsQty: {
            handler(newVal) {
                if (newVal > 0 && this.swiperInstance) {
                    setTimeout(() => {
                        equalizePurchaseSlides(this.swiperInstance);
                        this.swiperInstance.update();
                        console.log('swiperInstance updated');
                    }, 100)

                }
            },
            immediate: true
        }
    },
    methods: {
        calculateHeights(swiper){
            if(window.innerWidth<1024) return;
            observeScalapay(swiper.$el[0], ()=> this.$nextTick(()=>equalizePurchaseSlides(swiper)))
            setTimeout(() => {
                equalizePurchaseSlides(swiper);
            }, 100);
        },
        afterInit(swiper) {
            if(window.innerWidth<1024) return;
            this.swiperInstance = swiper;
            observeScalapay(swiper.$el[0], ()=> this.$nextTick(()=>equalizePurchaseSlides(swiper)))
            setTimeout(() => {
                equalizePurchaseSlides(swiper);
            }, 100);

        },
        getFirstPriceLabelProp(product) {
            return getFirstPriceLabel(product, this.paymentFrequenciesChoosen[product.sku], this.i18n, this.$fc)
        },
        getSecondPriceLabelProp(product) {
            return getSecondPriceLabel(product, this.paymentFrequenciesChoosen[product.sku], this.i18n, this.$fc)
        },
        changeFrequency(product, val) {
            this.paymentFrequenciesChoosen[product.sku] = val;
            this.$forceUpdate()
        },
        onSwiperResize(swiper) {
            equalizePurchaseSlides(swiper);
            console.log('swiper resized');
        },
    }
})
